export class ListViewsSetActiveAction {
  constructor(public view: string) {}
}
